/**
 * Generation guard for retryable async init sequences.
 *
 * Each call to begin() supersedes previous attempts. A superseded attempt's
 * continuation sees isCurrent() === false and must bail out before registering
 * callbacks or mutating state — this is how a timed-out / retried Krypton init
 * prevents a late (zombie) resolution from acting. withTimeout() does NOT cancel
 * the original promise, so this guard is the thing that actually neutralises it.
 */
export type Attempt = { gen: number; isCurrent: () => boolean };

export function createAttemptGuard() {
  let current = 0;
  return {
    begin(): Attempt {
      const gen = ++current;
      return { gen, isCurrent: () => current === gen };
    },
    /** The generation number of the latest attempt (for assertions/telemetry). */
    currentGen: () => current,
  };
}
